<template lang="pug">
    footer.footer.color-white
        .row
            .col-12.col-sm-6.text-center.text-sm-left
                template(v-if="lastAddresses.length")
                    h3 Where
                    .dropdown(v-click-outside="clickOutsideDropdown")
                        button#location-menu.btn.btn-secondary.dropdown-toggle(type="button" data-bs-toggle="dropdown" aria-expanded="false" @click="showDropdownMenu = !showDropdownMenu") {{ lastAddresses[0] }}
                        ul.dropdown-menu(aria-labelledby="location-menu" :class="{ show: showDropdownMenu }")
                            li(v-for="address in lastAddresses")
                                a.dropdown-item(@click="selectAddress(address)") {{ address }}
            .col-12.col-sm-6.text-center.text-sm-right
                h3 Follow Us
                ul.list-inline.m-0
                    li.list-inline-item
                        a(href="https://twitter.com/TOGGroleplay" target="_blank")
                            img(:src="`${baseUri}/images/client/lairdnd/cib_twitter.svg`")
                    li.list-inline-item
                        a(href="https://www.youtube.com/c/totallyonlinggaminggroup" target="_blank")
                            img(:src="`${baseUri}/images/client/lairdnd/ant-design_youtube-outlined.svg`")
                    li.list-inline-item
                        a(href="https://www.instagram.com/toggroleplay/" target="_blank")
                            img(:src="`${baseUri}/images/client/lairdnd/akar-icons_instagram-fill.svg`")
                    li.list-inline-item
                        a(href="https://www.twitch.tv/TOGGDM" target="_blank")
                            img(:src="`${baseUri}/images/client/lairdnd/feather_twitch.svg`")
        .row.footer-menu
            .col-md-12.text-center
                ul.list-inline.m-0
                    li.list-inline-item
                        router-link(:to="{ name: 'home-page' }") Home
                    li.list-inline-item
                        a(href="/complaint-form") Complaint
                    li.list-inline-item
                        a(href="/faq") FAQ
                    li.list-inline-item
                        a(href="/contact-us") Contact Us
                    li.list-inline-item
                        a(href="/blog") Blog
                    li.list-inline-item
                        a(href="/privacy-policy") Privacy Policy
                    li.list-inline-item
                        a(href="/terms-conditions") Terms & Conditions

        .row.footer-copyrights.text-center
            .col-md-12 © {{ year }} Lair-dnd All rights reserved

</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'

export default {
    name: 'layout-footer',

    data() { return {
        year: moment().format('Y'),
        showDropdownMenu: false,
    }},

    computed: {
        lastAddresses() {
            return this.$store.getters['Client/Lairdnd/lastAddresses']
        },
    },

    methods: {
        ...mapActions({
            setAddress: 'Client/Lairdnd/setAddress',
        }),
        
        selectAddress(address) {
            this.setAddress(address)
            const slug = _.kebabCase(address)
            this.$router.push({ name: 'game-master-directory-page', params: { cityDashState: slug } })
            this.showDropdownMenu = false
        },

        clickOutsideDropdown() {
            this.showDropdownMenu = false
        },
    }
}
</script>
